import { render, staticRenderFns } from "./CustomAlert.vue?vue&type=template&id=e2756b36&scoped=true&"
import script from "./CustomAlert.vue?vue&type=script&lang=js&"
export * from "./CustomAlert.vue?vue&type=script&lang=js&"
import style0 from "./CustomAlert.vue?vue&type=style&index=0&id=e2756b36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2756b36",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
